import styled from '@emotion/styled';
import { breakpoints, colors, fontWeights, gutterSizes, mediaQuery } from '../base/theme';

export const RadioWithLabelLi = styled.li<{ border: boolean, checked: boolean }>`
    && {
        position: relative;
        
        ${({ border, checked }) => border && `
            border: 1px solid ${checked ? colors.blade : colors.newBorder};
        `}

        .hint-tooltip {
            margin: 0 0 -${gutterSizes.base} ${gutterSizes.base};

            .btn-link {
                line-height: inherit;
            }

            ${mediaQuery.from(breakpoints.small)} {
                .hint-tooltip-content--left {
                    transform: translateX(-52px);
                }
            }
        }

        &.is-disabled {
            & > span {
                color: ${colors.bark60};
                cursor: auto;

                &:before {
                    background: ${colors.branch10};
                    border-color: ${colors.newLigthGrey};
                }
            }
        }
    }
`;

export const RadioSwitch = styled.input<{ border: boolean, checked: boolean }>`
    display: none;

    & + label,
    & + span {
        display: flex;
        align-items: center;
        cursor: pointer;
        font-weight: ${fontWeights.normal};
        width: ${({ border }) => border ? 'auto' : '100%'};
        padding: 0 ${gutterSizes.xxxlarge} 0 0;
        margin-bottom: ${({ border }) => border ? '0' : gutterSizes.base};
        position: relative;
        vertical-align: middle;

        &:before {
            content: '';
            background: ${colors.white};
            border-radius: 40px;
            border: 1px solid ${colors.bark40};
            width: ${({ border }) => border ? '20px' : '24px'};
            height: ${({ border }) => border ? '20px' : '24px'};
            margin-top: -${gutterSizes.medium};
            position: absolute;
            top: 50%;
            left: auto;
            right: 0;
            vertical-align: middle;
        }
    }

    &:checked + label {
        &:before {
            border: 1px solid ${colors.blade};
            background: ${({ border }) => border ? colors.blade : colors.green};
            background: radial-gradient(
                ellipse at center,
                ${({ border }) => border ? colors.blade : colors.green} 0,
                ${({ border }) => border ? colors.blade : colors.green} 39%,
                #fff 44%,
                #fff 100%
            );
        }
    }
`;
